import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { ThemeProvider } from "@/lib/theme";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AttributionTracker } from "@/components/shared/AttributionTracker";

import Landing from "@/pages/Landing";
import SampleDeal from "@/pages/SampleDeal";
import Auth from "@/pages/Auth";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import DealFlow from "@/pages/DealFlow";
import DealDetail from "@/pages/DealDetail";
import Intelligence from "@/pages/Intelligence";
import IntelligenceDetail from "@/pages/IntelligenceDetail";
import Playbooks from "@/pages/Playbooks";
import DealRoom from "@/pages/DealRoom";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <AttributionTracker />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/sample" element={<SampleDeal />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/pricing" element={<Pricing />} />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/deals"
                element={
                  <ProtectedRoute>
                    <DealFlow />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/deals/:id"
                element={
                  <ProtectedRoute>
                    <DealDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/intelligence"
                element={
                  <ProtectedRoute>
                    <Intelligence />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/intelligence/:id"
                element={
                  <ProtectedRoute>
                    <IntelligenceDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/playbooks"
                element={
                  <ProtectedRoute>
                    <Playbooks />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/deal-room"
                element={
                  <ProtectedRoute>
                    <DealRoom />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account"
                element={
                  <ProtectedRoute>
                    <Account />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{ style: { background: "hsl(var(--surface-elevated))", border: "1px solid hsl(var(--border))" } }}
          />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
